import {Component, OnDestroy, OnInit} from '@angular/core';
import {Apollo, gql} from 'apollo-angular';
import {Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {notNull} from '../../shared/utils';
import {
  ClientProgressComponent_getClient,
  ClientProgressComponent_getClient_user,
  ClientProgressComponent_getClient_user_moodSnapshots_edges_node,
  ClientProgressComponent_getClientVariables,
} from './__generated__/ClientProgressComponent_getClient';
import {ClientService} from '../../shared/services/client.service';

const GET_CLIENT = gql`
  query ClientProgressComponent_getClient($id: ID!) {
    user(id: $id) {
      id # Required
      username # Phone number in case of clients
      fullname
      day

      moodSnapshots(orderBy: ["-day"]) {
        edges {
          node {
            id
            date
            day
          }
        }
      }
    }
  }
`;

@Component({
  selector: 'app-client-progress',
  templateUrl: './client-progress.component.html',
  styleUrls: ['./client-progress.component.scss'],
})
export class ClientProgressComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];

  currWeek = 3;
  currDay = 4;
  currDelay = 0;

  user: ClientProgressComponent_getClient_user | null = null;
  private userId: string | null = null;
  moodSnapshots: ClientProgressComponent_getClient_user_moodSnapshots_edges_node[] = [];
  currentDate = new Date();
  fullDay = 0;

  constructor(
    private apollo: Apollo,
    private route: ActivatedRoute,
    private clientService: ClientService,
  ) {}

  ngOnInit(): void {
    this.userId = notNull(this.route.parent).snapshot.params['id'];

    this.subscriptions.push(
      this.apollo
        .watchQuery<ClientProgressComponent_getClient, ClientProgressComponent_getClientVariables>({
          query: GET_CLIENT,
          variables: {id: notNull(this.userId)},
        })
        .valueChanges.subscribe(results => {
          this.user = results.data.user;
          this.fullDay = notNull(this.user).day;
          const [week, remainderDay] = this.clientService.splitWeekDay(notNull(this.user).day);
          this.currWeek = week;
          this.currDay = remainderDay;
          this.moodSnapshots = notNull(this.user).moodSnapshots.edges.map(e => e.node);
        }),
    );
  }

  getLastSnapshot() {
    if (this.moodSnapshots.length == 0) {
      return null;
    }

    return this.moodSnapshots[this.moodSnapshots.length - 1];
  }

  convertDayToDisplay(day: number) {
    return this.clientService.convertDayToDisplay(day);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
